<div class="d-flex align-items-center">
    <mat-icon class="material-symbols-outlined text-body text-white"
              [style.color]="'white !important'">
        {{ data.icon }}
    </mat-icon>
    <span class="ms-2">
        {{ data.message }}
    </span>
</div>